

export default function testInfoSec(form) {

    $('.slider-for').slick({
        adaptiveHeight: true,
        arrows: true,
        asNavFor: '.slider-nav,.slider-x',
        appendArrows:$(".slider-for-arrows"),
        prevArrow: '<button class="btn  btn-link slide-arrow prev-arrow" aria-label="Left arrow"><span class="icon-arrow-left1 " ></span></button>',
        nextArrow: '<button class="btn  btn-link slide-arrow next-arrow" aria-label="Right arrow"><span class="icon-arrow-right1 "></span></button>'
    });
    $('.slider-x').slick({
        arrows: false,
        asNavFor: '.slider-for,.slider-nav',
    });
    $('.slider-nav').slick({
        arrows: false,
        asNavFor: '.slider-for,.slider-x',
        dots: true,
        focusOnSelect: true,
        slidesToShow: 3,
       
    });
}